






































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { goToWebinar } from "@/plugins/go-to";

@Component({
  components: { CustomTableItem, CustomTableCol }
})
export default class homeWebinarTables extends Vue {
  @Prop() webinar!: IWebinar;
  @Prop() accessTokenDev?: any;
  @Prop() accessTokenProd?: any;
  currentAccessToken!: string;
  data() {
    return {
      currentAccessToken: undefined
    };
  }

  goToWebinarLink() {
    goToWebinar(this.webinar.id, this.currentAccessToken);
  }

  created() {
    this.currentAccessToken = this.accessTokenDev
      ? this.accessTokenDev.accessToken
      : this.accessTokenProd.accessToken;
  }

  get styleForWebinarStatus() {
    let name = "";
    if (this.webinar.status === "coming") name = "webinar_local_coming";
    if (this.webinar.status === "running") name = "webinar_local_running";
    return name;
  }

  get webinarStatus() {
    let webinarStatus: string = "";
    if (this.webinar.status === "coming")
      webinarStatus = this.$tc(this.$translate.Planned);
    if (this.webinar.status === "running")
      webinarStatus = this.$tc(this.$translate.Online);
    return webinarStatus;
  }
}
